import { render, staticRenderFns } from "./vocs.vue?vue&type=template&id=23beb9b2&scoped=true&"
import script from "./vocs.vue?vue&type=script&lang=js&"
export * from "./vocs.vue?vue&type=script&lang=js&"
import style0 from "./vocs.vue?vue&type=style&index=0&id=23beb9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23beb9b2",
  null
  
)

export default component.exports